export enum NetArea {
  NORTH,
  MIDDLE,
  SOUTH,
  WEST,
  NO_CODE,
}
